import type { ProviderProductType } from "../admin/providers/providersApi";
import type { InvoiceSellerId } from "../orders/ordersApi";

const sellerByProductTypeMap: Record<ProviderProductType, InvoiceSellerId> = {
  HOTEL: "B2B_HOTELS",
  HOTEL_VAT_NP: "B2B_HOTELS",
  ATTRACTION: "PRZEZMORZE",
  PLANE_TICKET_VAT_0: "PRZEZMORZE",
  PLANE_TICKET_VAT_NP: "PRZEZMORZE",
  BUS_TRANSPORT_VAT_NP: "PRZEZMORZE",
  BUS_TRANSPORT_VAT_8: "PRZEZMORZE",
  WATERBORNE_TRANSPORT_VAT_0: "PRZEZMORZE",
  WATERBORNE_TRANSPORT_VAT_NP: "PRZEZMORZE",
};

export function sellerByProductType(type?: ProviderProductType) {
  return type ? sellerByProductTypeMap[type] : "PRZEZMORZE";
}
